module.exports = __webpack_public_path__ + "static/media/ic_dropdown.1c4d0b68.svg";